import CenteredPageLayout from 'src/components/templates/centered-page-layout/CenteredPageLayout';
import SignInForm from 'src/components/organisms/sign-in-form/SignInForm';

const SignIn = (): JSX.Element => {
  return (
    <CenteredPageLayout>
      <SignInForm />
    </CenteredPageLayout>
  );
};

export default SignIn;
